import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import rolesApi from 'Api/axios/roles-api';
import { usePermissionStore } from 'stores';

export const usePermissionsHydration = (): void => {
  const { roleId } = useSelector(userSelector);
  const setPermissions = usePermissionStore(state => state.setPermissions);

  useEffect(() => {
    if (!roleId) return;
    rolesApi.readPermissions(roleId).then(response => {
      if (response.data) {
        setPermissions(response.data.permissions);
      }
    });
  }, [roleId, setPermissions]);
};
